export interface BankAccount {
    id: number
    account_name: string
    account_number: string
    bank_name: string
    bank_code: string
    recipient_code: string
    hub_id: number
}

export function CreateNewBankAccount(): BankAccount {
    return {
        id: 0,
        account_name: '',
        account_number: '',
        bank_name: '',
        bank_code: '',
        recipient_code: '',
        hub_id: 0
    };
}

export function createBankAccountPayload(account: BankAccount) {
    return {
        account_name: account.account_name,
        account_number: account.account_number,
        bank_name: account.bank_name,
        bank_code: account.bank_code,
        hub_id: account.hub_id
    }
}